import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { toast } from 'react-toastify';

import { fetchUpdateSKUSet } from '../../../../actions/items';
import { showModal } from '../../../../actions/modal';

import { parseError } from '../../../../helpers';
import Adaptive from '../../../common/Adaptive';
import DesktopComponent from './DesktopComponent';
import MobileComponent from './MobileComponent';

const SinglePhysicalSet = (props) => {
  const history = useHistory();

  const [currentProduct, setCurrentProduct] = useState(null);
  const [physicalSet, setPhysicalSet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentActionType, setCurrentActionType] = useState(null);

  useEffect(() => {
    const parsedActionType = qs.parse(props.location?.search)?.['?currentActionType'] ?? null;
    if (parsedActionType) {
      setCurrentActionType(parsedActionType);
    } else {
      history.push('/physical-sets-journal');
    }
  }, []);

  const dispatch = useDispatch();

  const handleChooseProduct = () => {
    dispatch(
      showModal('ChooseProductForPhysicalSet', {
        submitCallback: (data) => {
          setCurrentProduct(data);
        },
      }),
    );
  };

  const handleUpdatePhysicalSet = (data) => {
    setPhysicalSet(data);
    return Promise.resolve();
  };

  const handleSavePhysicalSet = () => {
    setLoading(true);
    dispatch(
      fetchUpdateSKUSet({
        id: currentProduct.id,
        skuType: 'PHYSICAL_SET',
        items: physicalSet
          .filter((p) => p.quantity)
          .map((p) => ({ id: p.variantId, quantity: p.quantity })),
      }),
    )
      .then(() => {
        toast.info('Комплект успешно сохранен');
        history.push(
          `/physical-set-order?addSet=${currentProduct.id}&currentActionType=${currentActionType}`,
        );
      })
      .catch((err) => {
        toast.error(parseError(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const adaptiveProps = {
    currentProduct,
    data: [{ items: physicalSet }],
    handleUpdatePhysicalSet,
    handleSavePhysicalSet,
    loading,
    physicalSet,
    handleChooseProduct,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopComponent}
      MobileComponent={MobileComponent}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default SinglePhysicalSet;
